/* Raindoor Design System v1.0 — PLP: barra de herramientas, vista, orden, chips activos,
   "Cargar más" y tile de video. Los filtros siguen siendo los de Dawn (facets.js). */
(function () {
  if (window.__rdPlp) return;
  window.__rdPlp = true;

  var COLS_KEY = 'rd_plp_cols';
  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }

  /* ---------- Vista 2 / 3 / 4 columnas ---------- */
  function setCols(n) {
    n = Number(n) || 4;
    document.documentElement.style.setProperty('--rd-plp-cols', n);
    $$('[data-rd-cols]').forEach(function (b) { b.classList.toggle('is-active', Number(b.dataset.rdCols) === n); });
    try { localStorage.setItem(COLS_KEY, String(n)); } catch (e) {}
  }

  /* ---------- Contador, filtros activos y chips ---------- */
  function syncFromFacets() {
    var params = new URLSearchParams(window.location.search);
    var n = 0;
    params.forEach(function (v, k) { if (k.indexOf('filter.') === 0 && v !== '') n++; });
    var fc = $('[data-rd-filter-count]');
    if (fc) fc.textContent = n ? ' (' + n + ')' : '';

    var countEl = $('#ProductCount, #ProductCountDesktop');
    var out = $('[data-rd-count]');
    if (countEl && out) {
      var m = countEl.textContent.match(/\d[\d.,]*/);
      if (m) {
        var total = parseInt(m[0].replace(/[.,]/g, ''), 10);
        out.textContent = total + (total === 1 ? ' producto' : ' productos');
      }
    }

    var box = $('[data-rd-active-chips]');
    var inner = $('[data-rd-active-chips-in]');
    if (!box || !inner) return;
    var seen = {};
    var links = $$('#main-collection-filters .active-facets facet-remove a[href], #main-collection-filters .active-facets a.active-facets__button[href]')
      .filter(function (a) {
        var key = a.getAttribute('href');
        var label = cleanLabel(a);
        if (!label || seen[key]) return false;
        seen[key] = true;
        return true;
      });
    inner.innerHTML = '';
    var clearHref = null;
    links.forEach(function (a) {
      var label = cleanLabel(a);
      if (/borrar|eliminar todo|limpiar|clear/i.test(label)) { clearHref = a.getAttribute('href'); return; }
      var chip = document.createElement('a');
      chip.className = 'rd-plp-chip';
      chip.href = a.getAttribute('href');
      chip.innerHTML = '<span></span><span class="x" aria-hidden="true">×</span>';
      chip.firstChild.textContent = label;
      inner.appendChild(chip);
    });
    if (inner.children.length) {
      var clear = document.createElement('a');
      clear.className = 'rd-plp-clear';
      var q = new URLSearchParams(window.location.search).get('q');
      clear.href = clearHref || (window.location.pathname + (q ? '?q=' + encodeURIComponent(q) : ''));
      clear.textContent = 'Limpiar todo';
      inner.appendChild(clear);
    }
    box.hidden = !inner.children.length;
  }

  function cleanLabel(a) {
    var c = a.cloneNode(true);
    $$('.visually-hidden, svg', c).forEach(function (n) { n.remove(); });
    return c.textContent.replace(/\s+/g, ' ').trim();
  }

  function goTo(url) {
    var u = new URL(url, window.location.origin);
    if (window.FacetFiltersForm && typeof FacetFiltersForm.renderPage === 'function') {
      FacetFiltersForm.renderPage(u.searchParams.toString(), null, true);
    } else {
      window.location.href = u.pathname + u.search;
    }
  }

  /* ---------- Cargar más ---------- */
  function loadMore(btn) {
    var box = btn.closest('[data-rd-more]');
    var next = box && box.dataset.next;
    if (!next) return;
    btn.disabled = true;
    btn.textContent = 'Cargando…';
    var url = next + (next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(box.dataset.sectionId);
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = $('#ProductGridContainer .product-grid');
        $$('.product-grid > li', doc).forEach(function (li) { list.appendChild(li); });
        var nextBox = $('[data-rd-more]', doc);
        var shown = $$('.product-grid > li:not(.rd-plp-tile)', document).length;
        var total = Number(box.dataset.total) || shown;
        var shownEl = $('[data-rd-shown]', box);
        if (shownEl) shownEl.textContent = Math.min(shown, total);
        var fill = $('.rd-plp-more__fill', box);
        if (fill) fill.style.width = Math.min(100, Math.round((shown / total) * 100)) + '%';
        box.dataset.next = nextBox ? nextBox.dataset.next : '';
        if (!box.dataset.next) btn.remove();
        else { btn.disabled = false; btn.textContent = 'Cargar más'; }
        initVideos();
      })
      .catch(function () { window.location.href = next; });
  }

  /* ---------- Tile de video "Shop the look" ---------- */
  function play(tile) {
    var v = $('video', tile);
    if (!v) return;
    if (!v.src && v.dataset.src) v.src = v.dataset.src;
    v.muted = true;
    tile.classList.add('is-playing');
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function stop(tile) {
    var v = $('video', tile);
    if (!v) return;
    v.pause();
    v.currentTime = 0;
    tile.classList.remove('is-playing');
  }
  function initVideos() {
    var hover = window.matchMedia('(hover: hover)').matches;
    $$('[data-rd-video]').forEach(function (tile) {
      if (tile.__rd) return;
      tile.__rd = true;
      if (hover) {
        tile.addEventListener('mouseenter', function () { play(tile); });
        tile.addEventListener('mouseleave', function () { stop(tile); });
      } else if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { e.isIntersecting ? play(tile) : stop(tile); });
        }, { threshold: 0.6 }).observe(tile);
      }
    });
  }

  /* ---------- Drawer de filtros ---------- */
  var COLORS = {
    negro: '#15120E', black: '#15120E', blanco: '#F4F1EA', white: '#F4F1EA', crudo: '#E8DFD1', ecru: '#E8DFD1',
    beige: '#D9CFBF', cafe: '#6B4A34', 'café': '#6B4A34', brown: '#6B4A34', camel: '#B08A5E', gris: '#9A9088',
    grey: '#9A9088', gray: '#9A9088', azul: '#2E3A4F', blue: '#2E3A4F', navy: '#1F2A44', celeste: '#A9C3D9',
    rojo: '#A4442E', red: '#A4442E', burdeo: '#5A2230', burgundy: '#5A2230', rosado: '#F3A7C3', rosa: '#F3A7C3',
    pink: '#F3A7C3', verde: '#5E7A55', green: '#5E7A55', oliva: '#6B6F5C', amarillo: '#E7C65A', naranjo: '#D98A4B',
    morado: '#6E4A7E', lila: '#B8A6CF', dorado: '#C9A45C', plateado: '#C7C7C7', denim: '#4A6285', multicolor: 'conic-gradient(#A4442E,#E7C65A,#5E7A55,#2E3A4F,#F3A7C3,#A4442E)'
  };
  function paintDots() {
    $$('[data-rd-color]').forEach(function (d) {
      var k = d.dataset.rdColor.normalize ? d.dataset.rdColor : d.dataset.rdColor;
      var hex = COLORS[k] || COLORS[k.normalize('NFD').replace(/[̀-ͯ]/g, '')] || null;
      if (!hex) {
        Object.keys(COLORS).some(function (name) { if (k.indexOf(name) > -1) { hex = COLORS[name]; return true; } return false; });
      }
      d.style.background = hex || '#E4DED5';
    });
  }

  function filterParams() {
    var form = $('[data-rd-filters-form]');
    var p = new URLSearchParams();
    var current = new URLSearchParams(window.location.search);
    /* En /search se conservan la búsqueda y sus opciones */
    ['q', 'type', 'options[prefix]', 'options[unavailable_products]'].forEach(function (k) {
      if (current.get(k)) p.set(k, current.get(k));
    });
    if (current.get('sort_by')) p.set('sort_by', current.get('sort_by'));
    if (!form) return p;
    $$('input[type="checkbox"]:checked', form).forEach(function (i) { p.append(i.name, i.value); });
    var price = $('[data-rd-price]', form);
    var r = price && $('input[name="rd_price"]:checked', price);
    if (r) {
      if (r.dataset.gte) p.set(price.dataset.gteName, r.dataset.gte);
      if (r.dataset.lte) p.set(price.dataset.lteName, r.dataset.lte);
    }
    return p;
  }

  var countTimer;
  var countReq = 0;
  function refreshCount() {
    clearTimeout(countTimer);
    countTimer = setTimeout(function () {
      var box = $('[data-rd-filters]');
      var out = $('[data-rd-filters-total]');
      if (!box || !out) return;
      var p = filterParams();
      p.set('section_id', box.dataset.sectionId);
      var id = ++countReq;
      box.classList.add('is-counting');
      fetch(window.location.pathname + '?' + p.toString())
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (id !== countReq) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var c = $('[data-rd-count]', doc);
          var m = c && c.textContent.match(/\d+/);
          if (m) out.textContent = m[0];
        })
        .catch(function () {})
        .then(function () { if (id === countReq) box.classList.remove('is-counting'); });
    }, 250);
  }

  function openFilters() {
    var box = $('[data-rd-filters]');
    if (!box) return;
    paintDots();
    box.hidden = false;
    document.documentElement.classList.add('rd-filters-open');
    setTimeout(function () { box.classList.add('is-open'); }, 20);
    var first = $('.rd-filters__head button', box);
    if (first) first.focus();
  }
  function closeFilters() {
    var box = $('[data-rd-filters]');
    if (!box || box.hidden) return;
    box.classList.remove('is-open');
    document.documentElement.classList.remove('rd-filters-open');
    setTimeout(function () { box.hidden = true; }, 300);
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-rd-filters-form]')) refreshCount();
  });

  /* Un radio de precio se puede desmarcar tocándolo de nuevo */
  document.addEventListener('mousedown', function (e) {
    var r = e.target.closest('[data-rd-price] label');
    if (!r) return;
    var input = $('input', r);
    input.dataset.was = input.checked ? '1' : '';
  });
  document.addEventListener('click', function (e) {
    var input = e.target.closest('[data-rd-price] input[type="radio"]');
    if (input && input.dataset.was === '1') { input.checked = false; input.dataset.was = ''; refreshCount(); }
  });

  /* ---------- Eventos ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var colsBtn = t.closest('[data-rd-cols]');
    if (colsBtn) return setCols(colsBtn.dataset.rdCols);

    if (t.closest('[data-rd-open-filters]')) return openFilters();
    if (t.closest('[data-rd-filters-close]')) return closeFilters();
    if (t.closest('[data-rd-filters-clear]')) {
      $$('[data-rd-filters-form] input').forEach(function (i) { i.checked = false; });
      return refreshCount();
    }
    if (t.closest('[data-rd-filters-apply]')) {
      var p = filterParams();
      window.location.href = window.location.pathname + (p.toString() ? '?' + p.toString() : '');
      return;
    }

    var sortBtn = t.closest('[data-rd-sort-btn]');
    var sortBox = $('[data-rd-sort]');
    if (sortBtn) {
      var menu = $('.rd-plp-sort__menu', sortBox);
      menu.hidden = !menu.hidden;
      sortBtn.setAttribute('aria-expanded', String(!menu.hidden));
      return;
    }
    var opt = t.closest('[data-rd-sort-value]');
    if (opt) {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', opt.dataset.rdSortValue);
      u.searchParams.delete('page');
      $$('[data-rd-sort-value]').forEach(function (b) { b.classList.toggle('is-active', b === opt); });
      var lbl = $('[data-rd-sort-label]');
      if (lbl) lbl.textContent = opt.textContent;
      $('.rd-plp-sort__menu').hidden = true;
      goTo(u.toString());
      return;
    }
    if (sortBox && !t.closest('[data-rd-sort]')) {
      var m = $('.rd-plp-sort__menu', sortBox);
      if (m) m.hidden = true;
    }

    var chip = t.closest('.rd-plp-chip, .rd-plp-clear');
    if (chip) {
      e.preventDefault();
      goTo(chip.href);
      return;
    }

    var more = t.closest('[data-rd-load-more]');
    if (more) loadMore(more);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var m = $('.rd-plp-sort__menu');
      if (m) m.hidden = true;
      closeFilters();
    }
  });

  function init() {
    if (!$('[data-rd-toolbar]')) return;
    var saved = 4;
    try { saved = Number(localStorage.getItem(COLS_KEY)) || 4; } catch (e) {}
    setCols(saved);
    syncFromFacets();
    initVideos();
    var grid = document.getElementById('ProductGridContainer');
    if (grid) {
      new MutationObserver(function () { syncFromFacets(); initVideos(); }).observe(grid, { childList: true });
    }
    var filters = document.getElementById('main-collection-filters');
    if (filters) new MutationObserver(syncFromFacets).observe(filters, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
